import type {
	batchReloginInput,
	createSenderInput,
	deleteManySendersInput,
	deleteSenderInput,
	getAllSendersInput,
	getSenderInput,
	senderHistoryInput,
	senderReloginInput,
	sendersFacetsInput,
	stopResumeManyInput,
	stopResumeSenderInput,
	updateSenderInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllSenders: getAllSendersInput;
	useCreateSender: createSenderInput;
	useGetSender: getSenderInput;
	useUpdateSender: updateSenderInput;
	useDeleteSender: deleteSenderInput;
	useStopResumeSender: stopResumeSenderInput;
	useSenderHistory: senderHistoryInput;
	useSenderRelogin: senderReloginInput;
	useSendersFacets: sendersFacetsInput;
	useStopResumeMany: stopResumeManyInput;
	useDeleteManySenders: deleteManySendersInput;
	useBatchUpdateSenderPriority: undefined;
	useBatchRelogin: batchReloginInput;
}

const SENDERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("senders", [
	"useGetAllSenders",
	"useCreateSender",
	"useGetSender",
	"useUpdateSender",
	"useDeleteSender",
	"useStopResumeSender",
	"useSenderHistory",
	"useSenderRelogin",
	"useSendersFacets",
	"useStopResumeMany",
	"useDeleteManySenders",
	"useBatchUpdateSenderPriority",
	"useBatchRelogin",
]);

export { SENDERS_SERVICE_KEYS };
